import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BlogContent } from '@app/model/blog-content.model';
import { BlogContentDataService } from '@app/services/blog-content-data.service';

@Component({
  selector: 'meu-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  blogContent: BlogContent;

  constructor(
    private blogContentDataService: BlogContentDataService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.blogContentDataService.getContent().subscribe((content) => {
      this.blogContent = content;

      
      try {
        this.changeDetectorRef.detectChanges();
      } catch (error) {
        // view already destroyed / detection in progress – safe to ignore
      }
    });
  }
}
